// src/data/megaMenu.js
export const megaMenuItems = [
  {
    key: "ecommerce",
    title: "فروشگاه آنلاین",
    items: [
      { label: "داشبورد فروشگاه", to: "/ecommerce" },
      { label: "محصولات (گرید)", to: "/products-grid" },
      { label: "محصولات (لیست)", to: "/products-list" },
      { label: "جزئیات محصول", to: "/products-details" },
      { label: "افزودن محصول", to: "/create-product" },
      { label: "سفارش‌ها", to: "/orders" },
      { label: "سبد خرید", to: "/cart" },
      { label: "تسویه حساب", to: "/checkout" },
    ],
  },
  {
    key: "sellers",
    title: "فروشندگان",
    items: [
      { label: "لیست فروشندگان", to: "/sellers" },
      { label: "جزئیات فروشنده", to: "/sellers-details" },
      { label: "افزودن فروشنده", to: "/create-seller" },
    ],
  },
  {
    key: "restaurant",
    title: "رستوران",
    items: [
      { label: "داشبورد رستوران", to: "/dashboard/restaurant" },
      { label: "منوها", to: "/restaurant/menus" },
      { label: "جزئیات غذا", to: "/restaurant/dish-details" },
    ],
  },
  {
    key: "invoices",
    title: "فاکتورها",
    items: [
      { label: "لیست فاکتورها", to: "/invoices" },
      { label: "ایجاد فاکتور", to: "/invoices/create" },
      { label: "ویرایش فاکتور", to: "/invoices/edit" },
    ],
  },
  {
    key: "users",
    title: "کاربران",
    items: [
      { label: "مدیریت کاربران", to: "/users" },
      { label: "افزودن کاربر", to: "/users/add-user" },
    ],
  },
];
